<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
import DatePicker from "vue2-datepicker";

/**
 * Contacts-grid component
 */
export default {
    page: {
    title: "Positivity Analysis",
    meta: [{ name: "description", content: appConfig.description }],
    },  
  components: { Layout, PageHeader,ModelListSelect,DatePicker},
  data() {
    return {
      filtermonths:{
        month1:'', month2:'', month3:'', month4:'', month5:'', month6:'',
        month7:'', month8:'', month9:'', month10:'', month11:'', month12:''
      },
      filterdays:{
        day1:'', day2:'', day3:'', day4:'', day5:'', day6:'', day7:''
      },
    test:[],
      chartselect: {
        data: 'bar',
        test: 'select',
        time: 'all',
        agerange: 'all',
        dateRange: 0
      },
      filtertest:{
        test: '',
        agerange: 'all',
        timerange: 'year',
      },
        timeFilters: [    
        { title: "Customise", value: "custom" },    
        { title: "All", value: "all" },
        { title: "Today", value: "today" },
        { title: "Yesterday", value: "yesterday" },
        { title: "Last 7 days", value: "last7" },
        { title: "Last 14 days", value: "last14" },
        { title: "Last 28 days", value: "last28" },
        { title: "This month", value: "month" },
        { title: "This quarter", value: "quarter" },
      ],

     TimeRangeFilters: [ 
        { title: "Last Year", value: "year" },
        { title: "Last 7 days", value: "last7D" },
        { title: "Last 4 Weeks", value: "last4W" },
        { title: "Last 8 Weeks", value: "last8W" },
        { title: "Last 3 Months", value: "last3M" },
        { title: "Last 6 Months", value: "last6M" },
      ],

      AgeRangeFilters: [ 
        { title: "All Ages", value: "all" },
        { title: "<5 Years", value: "<5" },
        { title: "5-9 Years", value: "5,9" },
        { title: "10-19 Years", value: "10,19" },
        { title: "20-34 Years", value: "20,34" },
        { title: "35-54 Years", value: "35,54" },
        { title: "55-69 Years", value: "55,69" },
        { title: "70+ Years", value: "70+" },
      ],

      title: "Positivity Analysis",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Positivity Analysis",
          active: true,
        },
      ],
      perPage: 10,
      filterOn: [],
      sortDesc: false,
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      pageOptions: [10, 25, 50, 100, 200, 1000],
      currentPage: 1,
      filter: null,
      filtered_data: [],
    };
  },
  computed: {
    ...mapGetters("reports", ["PositivityData"]),
    ...mapGetters("reports", ["TestPositivityData"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.filtered_data ? this.filtered_data.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filtered_data ? this.filtered_data.length : 1;
  },
  methods: {
    ...mapActions({
      FetchPositivity: "reports/fetchPositivity",
      FetchTestPositivity: "reports/fetchTestPositivity",
    }),
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    setLabel() {
      if (this.chartselect.time == "today") {
        this.graphLabel = "today";
        this.chartselect.dateRange = "";
      }
      if (this.chartselect.time == "yesterday") {
        this.graphLabel = "yesterday";
        this.chartselect.dateRange = "";
      }
      if (this.chartselect.time == "last7") {
        this.graphLabel = "in last 7 days";
        this.chartselect.dateRange = "";
      }
      if (this.chartselect.time == "last14") {
        this.graphLabel = "in last 14 days";
        this.chartselect.dateRange = "";
      }
      if (this.chartselect.time == "last28") {
        this.graphLabel = "in last 28 days";
        this.chartselect.dateRange = "";
      }
      if (this.chartselect.time == "month") {
        this.graphLabel = "in this month";
        this.chartselect.dateRange = "";
      }
      if (this.chartselect.time == "quarter") {
        this.graphLabel = "in this quarter";
        this.chartselect.dateRange = "";
      }
      if (this.chartselect.time == "all") {
        this.graphLabel = "for all time";
        this.chartselect.dateRange = "";
      }
      if (this.chartselect.time == "custom") {
        this.graphLabel = "";
        this.chartselect.dateRange = "";
      }
    },
    setTestLabel() {
      if (this.filtertest.timerange == "all") {
        this.graphLabel = "for all time";
      }
      if (this.filtertest.timerange == "last7D") {
        this.graphLabel = "in last 7 days";
      }
      if (this.filtertest.timerange == "last4W") {
        this.graphLabel = "in last 4 Weeks";
      }
      if (this.filtertest.timerange == "last8W") {
        this.graphLabel = "in last 8 Weeks";
      }
      if (this.filtertest.timerange == "last3M") {
        this.graphLabel = "in last 3 Months";
      }
      if (this.filtertest.timerange == "last6M") {
        this.graphLabel = "in last 6 Months";
      }
      if (this.filtertest.timerange == "year") {
        this.graphLabel = "in last year";
      }
    },

    FilterPositivity() {
      if (this.chartselect.time == "custom" && this.chartselect.dateRange == "") {
        return;
      }
      if (
        this.chartselect.time == "custom" &&
        this.chartselect.dateRange[0] == null &&
        this.chartselect.dateRange[1] == null
      ) {
        return;
      }
      this.FetchPositivity(this.chartselect);
    },
    //Per department graphs    
    TestCheck(){
      this.setTestLabel();
      if (this.chartselect.test != 'select' && this.chartselect.time == "custom" && this.chartselect.dateRange == "") {
        return;
      }
      if (
        this.chartselect.test != 'select' &&
        this.chartselect.time == "custom" &&
        this.chartselect.dateRange[0] == null &&
        this.chartselect.dateRange[1] == null
      ) {
        return;
      }
      if(this.chartselect.test != 'select'){
        this.filtertest.test = this.chartselect.test;
        this.FetchTestPositivity(this.filtertest);        
      }      
    }

  },
  watch: {
    TestPositivityData(newValue) {
      if (newValue) {
        if(this.chartselect.test != 'select' && this.filtertest.timerange == 'year' || this.filtertest.timerange == 'last6M' || this.filtertest.timerange == 'last3M')  {
          const current = new Date();
          current.setMonth(current.getMonth()-1);
          this.filtermonths.month1 = current.toLocaleString('default', { month: 'long' });
          current.setMonth(current.getMonth()-1);
          this.filtermonths.month2 = current.toLocaleString('default', { month: 'long' });
          current.setMonth(current.getMonth()-1);
          this.filtermonths.month3 = current.toLocaleString('default', { month: 'long' }); 
          current.setMonth(current.getMonth()-1);
          this.filtermonths.month4 = current.toLocaleString('default', { month: 'long' }); 
          current.setMonth(current.getMonth()-1);
          this.filtermonths.month5 = current.toLocaleString('default', { month: 'long' });   
          current.setMonth(current.getMonth()-1);
          this.filtermonths.month6 = current.toLocaleString('default', { month: 'long' });  
          current.setMonth(current.getMonth()-1);
          this.filtermonths.month7 = current.toLocaleString('default', { month: 'long' });  
          current.setMonth(current.getMonth()-1);
          this.filtermonths.month8 = current.toLocaleString('default', { month: 'long' }); 
          current.setMonth(current.getMonth()-1);
          this.filtermonths.month9 = current.toLocaleString('default', { month: 'long' });
          current.setMonth(current.getMonth()-1);
          this.filtermonths.month10 = current.toLocaleString('default', { month: 'long' });
          current.setMonth(current.getMonth()-1);
          this.filtermonths.month11 = current.toLocaleString('default', { month: 'long' });
          current.setMonth(current.getMonth()-1);
          this.filtermonths.month12 = current.toLocaleString('default', { month: 'long' });
        }else if(this.chartselect.test != 'select' && this.filtertest.timerange == 'last7D')  {       
          this.filterdays.day1 = new Date((new Date()).valueOf() - 1000*60*60*24).toDateString();
          this.filterdays.day2 = new Date((new Date()).valueOf() - 1000*60*60*48).toDateString();
          this.filterdays.day3 = new Date((new Date()).valueOf() - 1000*60*60*64).toDateString();
          this.filterdays.day4 = new Date((new Date()).valueOf() - 1000*60*60*72).toDateString();
          this.filterdays.day5 = new Date((new Date()).valueOf() - 1000*60*60*96).toDateString();
          this.filterdays.day6 = new Date((new Date()).valueOf() - 1000*60*60*120).toDateString();
          this.filterdays.day7 = new Date((new Date()).valueOf() - 1000*60*60*144).toDateString();
        }
      }
    }
  },
  created() {    
    this.FetchPositivity(this.chartselect);
 
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" /> 
    <div class="card">      
        <div class="card-body">
          <div class="row justify-content-end">
            <div class="col-md-3 mt-4"> 
              <router-link to="/reports/positivity_rate"><button class="btn btn-success"><i class="fa fa-list"></i>Graphic View</button></router-link>
            </div> 
            <div class="col-md-3">
              <label for="">Select Test</label>
              <select class="form-control" @change="TestCheck();" v-model="chartselect.test">
                <option value="select">All Tests</option>
                <option v-if="PositivityData[0]" :value="PositivityData[0].name">{{PositivityData[0]?PositivityData[0].name:''}}</option>
                <option v-if="PositivityData[1]" :value="PositivityData[1].name">{{PositivityData[1]?PositivityData[1].name:''}}</option>
                <option v-if="PositivityData[2]" :value="PositivityData[2].name">{{PositivityData[2]?PositivityData[2].name:''}}</option>
                <option v-if="PositivityData[3]" :value="PositivityData[3].name">{{PositivityData[3]?PositivityData[3].name:''}}</option>
                <option v-if="PositivityData[4]" :value="PositivityData[4].name">{{PositivityData[4]?PositivityData[4].name:''}}</option>
                <option v-if="PositivityData[5]" :value="PositivityData[5].name">{{PositivityData[5]?PositivityData[5].name:''}}</option>
                <option v-if="PositivityData[6]" :value="PositivityData[6].name">{{PositivityData[6]?PositivityData[6].name:''}}</option>
                <option v-if="PositivityData[7]" :value="PositivityData[7].name">{{PositivityData[7]?PositivityData[7].name:''}}</option>
                <option v-if="PositivityData[8]" :value="PositivityData[8].name">{{PositivityData[8]?PositivityData[8].name:''}}</option>
                <option v-if="PositivityData[9]" :value="PositivityData[9].name">{{PositivityData[9]?PositivityData[9].name:''}}</option>
              </select>
            </div>
            <div v-if="chartselect.test == 'select'" class="col-md-3">
              <label for="">Select time frame</label>
              <model-list-select
                :list="this.timeFilters ? this.timeFilters : []"
                v-model="chartselect.time"
                option-value="value"
                size="sm"
                @input="                  
                  FilterPositivity();
                  setLabel();
                "
                option-text="title"
                placeholder="Select Time-frame"
              >
              </model-list-select>
            </div>
            <div v-if="chartselect.time == 'custom' && chartselect.test == 'select'" class="col-md-2 mt-4">
              <date-picker
                v-model="chartselect.dateRange"
                range
                append-to-body
                @change="FilterPositivity"
                lang="en"
                confirm
              ></date-picker>
            </div> 
            <div class="col-md-3" v-if="chartselect.test == 'select'"> 
              <label for="">Select Age-range</label>
              <model-list-select
                :list="this.AgeRangeFilters ? this.AgeRangeFilters : []"
                v-model="chartselect.agerange"
                option-value="value"
                size="sm"
                @input="                  
                  FilterPositivity();
                  setLabel();
                "
                option-text="title"
                placeholder="Select Time-frame"
              >
              </model-list-select>
            </div>  
            <div class="col-md-3" v-if="chartselect.test != 'select'"> 
              <label for="">Select Age-range</label>
              <model-list-select
                :list="this.AgeRangeFilters ? this.AgeRangeFilters : []"
                v-model="filtertest.agerange"
                option-value="value"
                size="sm"
                @input="                  
                  TestCheck();
                  setTestLabel();
                "
                option-text="title"
                placeholder="Select Time-frame"
              >
              </model-list-select>
            </div>  
            <div class="col-md-3" v-if="chartselect.test != 'select'">
              <label for="">Select Time-frame</label>
              <model-list-select
                :list="this.TimeRangeFilters ? this.TimeRangeFilters : []"
                v-model="filtertest.timerange"
                option-value="value"
                size="sm"
                @input="                  
                  TestCheck();
                  setTestLabel();
                "
                option-text="title"
                placeholder="Select Time-frame"
              >
              </model-list-select>
            </div>    
          </div>
        </div>
      </div>
 <div>
    <div class="row mt-4">
      <h4 class="card-title mb-4">Test Positivity Analysis {{ graphLabel }}</h4>
              <!-- <div class="col-md-6 mb-2">
                <b-button variant="primary" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                >
              </div> -->
            </div>
            <!-- Table -->
            <div class="row">
            <div class="col-md-5 table-responsive mb-0">
              <table border="1" style="width:100%;">
                <thead>
                    <tr>
                        <th>S/No.</th>
                        <th>Test</th>
                        <th>Total tests</th>
                        <th>Positives</th>
                        <th>Positivity Rate(%ge)</th>
                    </tr>                    
                </thead>
                <tbody>
                    <tr v-if="PositivityData[0]">
                        <td>1</td>
                        <td>{{PositivityData[0]?PositivityData[0].name:''}}</td>
                        <td>{{PositivityData[0]?PositivityData[0].All_tests:''}}</td>
                        <td>{{PositivityData[0]?PositivityData[0].positives:''}}</td>
                        <td>{{PositivityData[0]?PositivityData[0].positivity_rate:''}}</td>
                    </tr> 
                    <tr v-if="PositivityData[1]">
                        <td>2</td>
                        <td>{{PositivityData[1]?PositivityData[1].name:''}}</td>
                        <td>{{PositivityData[1]?PositivityData[1].All_tests:''}}</td>
                        <td>{{PositivityData[1]?PositivityData[1].positives:''}}</td>
                        <td>{{PositivityData[1]?PositivityData[1].positivity_rate:''}}</td>
                    </tr>
                    <tr v-if="PositivityData[2]">
                        <td>3</td>
                        <td>{{PositivityData[2]?PositivityData[2].name:''}}</td>
                        <td>{{PositivityData[2]?PositivityData[2].All_tests:''}}</td>
                        <td>{{PositivityData[2]?PositivityData[2].positives:''}}</td>
                        <td>{{PositivityData[2]?PositivityData[2].positivity_rate:''}}</td>
                    </tr>
                    <tr v-if="PositivityData[3]">
                        <td>4</td>
                        <td>{{PositivityData[3]?PositivityData[3].name:''}}</td>
                        <td>{{PositivityData[3]?PositivityData[3].All_tests:''}}</td>
                        <td>{{PositivityData[3]?PositivityData[3].positives:''}}</td>
                        <td>{{PositivityData[3]?PositivityData[3].positivity_rate:''}}</td>
                    </tr>
                    <tr v-if="PositivityData[4]">
                        <td>5</td>
                        <td>{{PositivityData[4]?PositivityData[4].name:''}}</td>
                        <td>{{PositivityData[4]?PositivityData[4].All_tests:''}}</td>
                        <td>{{PositivityData[4]?PositivityData[4].positives:''}}</td>
                        <td>{{PositivityData[4]?PositivityData[4].positivity_rate:''}}</td>
                    </tr>
                    <tr v-if="PositivityData[5]">
                        <td>6</td>
                        <td>{{PositivityData[5]?PositivityData[5].name:''}}</td>
                        <td>{{PositivityData[5]?PositivityData[5].All_tests:''}}</td>
                        <td>{{PositivityData[5]?PositivityData[5].positives:''}}</td>
                        <td>{{PositivityData[5]?PositivityData[5].positivity_rate:''}}</td>
                    </tr>
                    <tr v-if="PositivityData[6]">
                        <td>7</td>
                        <td>{{PositivityData[6]?PositivityData[6].name:''}}</td>
                        <td>{{PositivityData[6]?PositivityData[6].All_tests:''}}</td>
                        <td>{{PositivityData[6]?PositivityData[6].positives:''}}</td>
                        <td>{{PositivityData[6]?PositivityData[6].positivity_rate:''}}</td>
                    </tr>
                    <tr v-if="PositivityData[7]">
                        <td>8</td>
                        <td>{{PositivityData[7]?PositivityData[7].name:''}}</td>
                        <td>{{PositivityData[7]?PositivityData[7].All_tests:''}}</td>
                        <td>{{PositivityData[7]?PositivityData[7].positives:''}}</td>
                        <td>{{PositivityData[7]?PositivityData[7].positivity_rate:''}}</td>
                    </tr>
                    <tr v-if="PositivityData[8]">
                        <td>9</td>
                        <td>{{PositivityData[8]?PositivityData[8].name:''}}</td>
                        <td>{{PositivityData[8]?PositivityData[8].All_tests:''}}</td>
                        <td>{{PositivityData[8]?PositivityData[8].positives:''}}</td>
                        <td>{{PositivityData[8]?PositivityData[8].positivity_rate:''}}</td>
                    </tr>
                    <tr v-if="PositivityData[9]">
                        <td>10</td>
                        <td>{{PositivityData[9]?PositivityData[9].name:''}}</td>
                        <td>{{PositivityData[9]?PositivityData[9].All_tests:''}}</td>
                        <td>{{PositivityData[9]?PositivityData[9].positives:''}}</td>
                        <td>{{PositivityData[9]?PositivityData[9].positivity_rate:''}}</td>
                    </tr>
                </tbody>
              </table>              
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-5 table-responsive mb-0" v-if="TestPositivityData?true:false">
              <table style="width:100%" v-if="this.chartselect.test != 'select' && filtertest.timerange == 'year' || filtertest.timerange == 'last6M' || filtertest.timerange == 'last3M'">
                <thead>
                    <tr>
                        <th>S/No.</th>
                        <th>Time range</th>
                        <th>Total Tests</th>
                        <th>Positive Tests</th>
                        <th>Positivity rate(%ge)</th>
                    </tr>                    
                </thead>
                <tbody>
                    <tr v-if="TestPositivityData.one_month">
                        <td>1</td>
                        <td>{{filtermonths.month1}}</td>
                        <td>{{TestPositivityData.one_month.All_tests}}</td>
                        <td>{{TestPositivityData.one_month.positives}}</td>
                        <td>{{TestPositivityData.one_month.positivity_rate}}</td>
                    </tr> 
                    <tr v-if="TestPositivityData.two_months">
                        <td>2</td>
                        <td>{{filtermonths.month2}}</td>
                        <td>{{TestPositivityData.two_months.All_tests}}</td>
                        <td>{{TestPositivityData.two_months.positives}}</td>
                        <td>{{TestPositivityData.two_months.positivity_rate}}</td>
                    </tr>
                    <tr v-if="TestPositivityData.three_months">
                        <td>3</td>
                        <td>{{filtermonths.month3}}</td>
                        <td>{{TestPositivityData.three_months.All_tests}}</td>
                        <td>{{TestPositivityData.three_months.positives}}</td>
                        <td>{{TestPositivityData.three_months.positivity_rate}}</td>
                    </tr>
                    <tr v-if="TestPositivityData.four_months">
                        <td>4</td>
                        <td>{{filtermonths.month4}}</td>
                        <td>{{TestPositivityData.four_months.All_tests}}</td>
                        <td>{{TestPositivityData.four_months.positives}}</td>
                        <td>{{TestPositivityData.four_months.positivity_rate}}</td>
                    </tr> 
                    <tr v-if="TestPositivityData.five_months">
                        <td>5</td>
                        <td>{{filtermonths.month5}}</td>
                        <td>{{TestPositivityData.five_months.All_tests}}</td>
                        <td>{{TestPositivityData.five_months.positives}}</td>
                        <td>{{TestPositivityData.five_months.positivity_rate}}</td>
                    </tr> 
                    <tr v-if="TestPositivityData.six_months">
                        <td>6</td>
                        <td>{{filtermonths.month6}}</td>
                        <td>{{TestPositivityData.six_months.All_tests}}</td>
                        <td>{{TestPositivityData.six_months.positives}}</td>
                        <td>{{TestPositivityData.six_months.positivity_rate}}</td>
                    </tr>
                    <tr v-if="TestPositivityData.seven_months">
                        <td>7</td>
                        <td>{{filtermonths.month7}}</td>
                        <td>{{TestPositivityData.seven_months.All_tests}}</td>
                        <td>{{TestPositivityData.seven_months.positives}}</td>
                        <td>{{TestPositivityData.seven_months.positivity_rate}}</td>
                    </tr>
                    <tr v-if="TestPositivityData.eight_months">
                        <td>8</td>
                        <td>{{filtermonths.month8}}</td>
                        <td>{{TestPositivityData.eight_months.All_tests}}</td>
                        <td>{{TestPositivityData.eight_months.positives}}</td>
                        <td>{{TestPositivityData.eight_months.positivity_rate}}</td>
                    </tr>
                    <tr v-if="TestPositivityData.nine_months">
                        <td>9</td>
                        <td>{{filtermonths.month9}}</td>
                        <td>{{TestPositivityData.nine_months.All_tests}}</td>
                        <td>{{TestPositivityData.nine_months.positives}}</td>
                        <td>{{TestPositivityData.nine_months.positivity_rate}}</td>
                    </tr>
                    <tr v-if="TestPositivityData.ten_months">
                        <td>10</td>
                        <td>{{filtermonths.month10}}</td>
                        <td>{{TestPositivityData.ten_months.All_tests}}</td>
                        <td>{{TestPositivityData.ten_months.positives}}</td>
                        <td>{{TestPositivityData.ten_months.positivity_rate}}</td>
                    </tr>
                    <tr v-if="TestPositivityData.eleven_months">
                        <td>11</td>
                        <td>{{filtermonths.month11}}</td>
                        <td>{{TestPositivityData.eleven_months.All_tests}}</td>
                        <td>{{TestPositivityData.eleven_months.positives}}</td>
                        <td>{{TestPositivityData.eleven_months.positivity_rate}}</td>
                    </tr>
                    <tr v-if="TestPositivityData.twelve_months">
                        <td>12</td>
                        <td>{{filtermonths.month12}}</td>
                        <td>{{TestPositivityData.twelve_months.All_tests}}</td>
                        <td>{{TestPositivityData.twelve_months.positives}}</td>
                        <td>{{TestPositivityData.twelve_months.positivity_rate}}</td>
                    </tr>
                </tbody>
              </table>
              <table style="width:100%" v-if="this.chartselect.test != 'select' && filtertest.timerange == 'last4W' || filtertest.timerange == 'last8W'">
                <thead>
                    <tr>
                        <th>S/No.</th>
                        <th>Time range</th>
                        <th>Total Tests</th>
                        <th>Positive Tests</th>
                        <th>Positivity rate(%ge)</th>
                    </tr>                    
                </thead>
                <tbody>
                    <tr v-if="TestPositivityData.one_week">
                        <td>1</td>
                        <td>1st Week</td>
                        <td>{{TestPositivityData.one_week.All_tests}}</td>
                        <td>{{TestPositivityData.one_week.positives}}</td>
                        <td>{{TestPositivityData.one_week.positivity_rate}}</td>
                    </tr>
                    <tr v-if="TestPositivityData.two_weeks">
                        <td>2</td>
                        <td>2nd Week</td>
                        <td>{{TestPositivityData.two_weeks.All_tests}}</td>
                        <td>{{TestPositivityData.two_weeks.positives}}</td>
                        <td>{{TestPositivityData.two_weeks.positivity_rate}}</td>
                    </tr> 
                    <tr v-if="TestPositivityData.three_weeks">
                        <td>3</td>
                        <td>3rd Week</td>
                        <td>{{TestPositivityData.three_weeks.All_tests}}</td>
                        <td>{{TestPositivityData.three_weeks.positives}}</td>
                        <td>{{TestPositivityData.three_weeks.positivity_rate}}</td>
                    </tr> 
                    <tr v-if="TestPositivityData.four_weeks">
                        <td>4</td>
                        <td>4th Week</td>
                        <td>{{TestPositivityData.four_weeks.All_tests}}</td>
                        <td>{{TestPositivityData.four_weeks.positives}}</td>
                        <td>{{TestPositivityData.four_weeks.positivity_rate}}</td>
                    </tr>
                    <tr v-if="TestPositivityData.five_weeks">
                        <td>5</td>
                        <td>5th Week</td>
                        <td>{{TestPositivityData.five_weeks.All_tests}}</td>
                        <td>{{TestPositivityData.five_weeks.positives}}</td>
                        <td>{{TestPositivityData.five_weeks.positivity_rate}}</td>
                    </tr> 
                    <tr v-if="TestPositivityData.six_weeks">
                        <td>6</td>
                        <td>6th Week</td>
                        <td>{{TestPositivityData.six_weeks.All_tests}}</td>
                        <td>{{TestPositivityData.six_weeks.positives}}</td>
                        <td>{{TestPositivityData.six_weeks.positivity_rate}}</td>
                    </tr>
                    <tr v-if="TestPositivityData.seven_weeks">
                        <td>7</td>
                        <td>7th Week</td>
                        <td>{{TestPositivityData.seven_weeks.All_tests}}</td>
                        <td>{{TestPositivityData.seven_weeks.positives}}</td>
                        <td>{{TestPositivityData.seven_weeks.positivity_rate}}</td>
                    </tr>
                    <tr v-if="TestPositivityData.eight_weeks">
                        <td>8</td>
                        <td>8th Week</td>
                        <td>{{TestPositivityData.eight_weeks.All_tests}}</td>
                        <td>{{TestPositivityData.eight_weeks.positives}}</td>
                        <td>{{TestPositivityData.eight_weeks.positivity_rate}}</td>
                    </tr>
                    
                </tbody>
              </table>
              <table style="width:100%" v-if="this.chartselect.test != 'select' && filtertest.timerange == 'last7D'">
                <thead>
                    <tr>
                        <th>S/No.</th>
                        <th>Time range</th>
                        <th>Total Tests</th>
                        <th>Positive Tests</th>
                        <th>Positivity rate(%ge)</th>
                    </tr>                    
                </thead>
                <tbody>
                    <tr v-if="TestPositivityData.one_day">
                        <td>1</td>
                        <td>{{filterdays.day1}}</td>
                        <td>{{TestPositivityData.one_day.All_tests}}</td>
                        <td>{{TestPositivityData.one_day.positives}}</td>
                        <td>{{TestPositivityData.one_day.positivity_rate}}</td>
                    </tr>
                    <tr v-if="TestPositivityData.two_days">
                        <td>2</td>
                        <td>{{filterdays.day2}}</td>
                        <td>{{TestPositivityData.two_days.All_tests}}</td>
                        <td>{{TestPositivityData.two_days.positives}}</td>
                        <td>{{TestPositivityData.two_days.positivity_rate}}</td>
                    </tr> 
                    <tr v-if="TestPositivityData.three_days">
                        <td>3</td>
                        <td>{{filterdays.day3}}</td>
                        <td>{{TestPositivityData.three_days.All_tests}}</td>
                        <td>{{TestPositivityData.three_days.positives}}</td>
                        <td>{{TestPositivityData.three_days.positivity_rate}}</td>
                    </tr> 
                    <tr v-if="TestPositivityData.four_days">
                        <td>4</td>
                        <td>{{filterdays.day4}}</td>
                        <td>{{TestPositivityData.four_days.All_tests}}</td>
                        <td>{{TestPositivityData.four_days.positives}}</td>
                        <td>{{TestPositivityData.four_days.positivity_rate}}</td>
                    </tr>
                    <tr v-if="TestPositivityData.five_days">
                        <td>5</td>
                        <td>{{filterdays.day5}}</td>
                        <td>{{TestPositivityData.five_days.All_tests}}</td>
                        <td>{{TestPositivityData.five_days.positives}}</td>
                        <td>{{TestPositivityData.five_days.positivity_rate}}</td>
                    </tr> 
                    <tr v-if="TestPositivityData.six_days">
                        <td>6</td>
                        <td>{{filterdays.day6}}</td>
                        <td>{{TestPositivityData.six_days.All_tests}}</td>
                        <td>{{TestPositivityData.six_days.positives}}</td>
                        <td>{{TestPositivityData.six_days.positivity_rate}}</td>
                    </tr>
                    <tr v-if="TestPositivityData.seven_days">
                        <td>7</td>
                        <td>{{filterdays.day7}}</td>
                        <td>{{TestPositivityData.seven_days.All_tests}}</td>
                        <td>{{TestPositivityData.seven_days.positives}}</td>
                        <td>{{TestPositivityData.seven_days.positivity_rate}}</td>
                    </tr>                    
                </tbody>
              </table>
            </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
 </div>
    <!-- end row -->
  </Layout>
</template>
<style>
table, th, td {
  border: 1px solid;
}
</style>